<template>

    <div class="helper-wrapper rows" :style="helperPos" :class="{ clsng : Global.tempHelperClosingOverlay }">
        <div class="duplicate-outer">
            <div class="nav-item ft-bld">
                <span class="ico">
                    <svg width="22" height="20" viewBox="0 0 22 20" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.535 1.92011L7.53499 1.92012L1.87636 6.86851C0.670333 7.92316 0.067318 8.45049 0.00954518 8.909C-0.0405105 9.30626 0.108372 9.70268 0.407563 9.96877C0.697128 10.2263 1.30715 10.2679 2.44125 10.2746V18.781C2.44125 19.452 2.98522 19.996 3.65625 19.996H7.70574C8.37677 19.996 8.92074 19.452 8.92074 18.781V14.7309C8.92074 14.0599 9.46472 13.5159 10.1357 13.5159H11.7557C12.4268 13.5159 12.9707 14.0599 12.9707 14.7309V18.781C12.9707 19.452 13.5147 19.996 14.1857 19.996H18.2362C18.9073 19.996 19.4513 19.452 19.4513 18.781V10.2746C20.587 10.2679 21.1977 10.2265 21.4875 9.96877C21.7867 9.70268 21.9356 9.30626 21.8855 8.909C21.8278 8.45049 21.2248 7.92316 20.0187 6.8685L14.3601 1.92011C13.1509 0.862714 12.5463 0.334014 11.866 0.132906C11.2665 -0.0443019 10.6286 -0.0443019 10.0291 0.132906C9.34875 0.334014 8.74417 0.862712 7.535 1.92011Z" fill="black"/>
                    </svg>
                </span>
                <span class="text">
                    <span class="og">Monetization</span>
                    <span class="cpy">Homepage</span>
                </span>
                <span class="act-bg"></span>
            </div>
        </div>
        <div class="tooltip-wrapper">
            <div class="tooltip-outer" @click.prevent="$parent.helperBgClick">
                <div class="tooltip">
                    <span class="ico">
                        <svg width="22" height="22" viewBox="0 0 27 27" fill="none">
                        <circle cx="13.5" cy="13.4999" r="12.25" stroke="url(#paint0_linear_1539_2667)" stroke-width="2.5"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5 10.2499C14.4665 10.2499 15.25 9.46638 15.25 8.49988C15.25 7.53338 14.4665 6.74988 13.5 6.74988C12.5335 6.74988 11.75 7.53338 11.75 8.49988C11.75 9.46638 12.5335 10.2499 13.5 10.2499ZM13 11.9999C12.4477 11.9999 12 12.4476 12 12.9999V17.9999C12 18.5522 12.4477 18.9999 13 18.9999H14C14.5523 18.9999 15 18.5522 15 17.9999V12.9999C15 12.4476 14.5523 11.9999 14 11.9999H13Z" fill="url(#paint1_linear_1539_2667)"/>
                        <defs>
                        <linearGradient id="paint0_linear_1539_2667" x1="27" y1="26.9999" x2="-2.28482" y2="24.2395" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#F3CA54"/>
                        <stop offset="1" stop-color="#FFBB36"/>
                        </linearGradient>
                        <linearGradient id="paint1_linear_1539_2667" x1="15.25" y1="18.9999" x2="11.4229" y2="18.8968" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#F3CA54"/>
                        <stop offset="1" stop-color="#FFBB36"/>
                        </linearGradient>
                        </defs>
                        </svg>
                    </span>
                    <p class="txt-main">Let’s discover how to organize your homepage contents with your own categories rows</p>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import Global from '../lib/GlobalState'

    export default {

        name: 'RowsHelperOverlay',

        components: {
            
        },

        props: {
            
        },

        data() {
            return {
                Global
            }
        },

        computed: {
            helperPos() {
                return { top : this.Global.RowsHelperOverlayPos.y + 'px', left : this.Global.RowsHelperOverlayPos.x + 'px' }
            }
        }
    }
</script>